import { useAuth } from '@unbooking/ui-auth';
import { useQuery } from 'react-query';

export function useDoPermissions() {
  const { axios, isAuthenticated } = useAuth();

  const { data } = useQuery({
    queryKey: ['dopermissions'],
    queryFn: () =>
      axios
        .get(process.env.REACT_APP_HBH_PERMISSION_ENDPOINT ?? '')
        .then(() => true)
        .catch(() => false),
    enabled: isAuthenticated,
  });

  return data == null ? isAuthenticated : data;
}
